<template>
    <div id="my-account-page">
        <AppHero
            :heading="'My Account'"
        >
            <p class="body-copy body-copy--align-center">Welcome {{ username }}</p>
        </AppHero>

        <YourPlan />

        <!-- <BrandTools /> -->

        <AccountSettings />

        <CallToAction
            :copy="'Which Khonsu Plan is best for me?'"
            :button-text="'Click here to view our different pricing models'"
            :button-link="'/our-packages'"
        />
    </div>
</template>

<script>
    import AppHero from "@/components/layout/AppHero";
    import YourPlan from "@/views/MyAccount/YourPlan";
    // import BrandTools from "@/views/MyAccount/brandTools";
    import AccountSettings from "@/views/MyAccount/AccountSettings";
    import CallToAction from "@/components/layout/CallToAction";
    import userMixin from "@/mixins/userMixin";

    export default {
        name: 'MyAccountPage',
        metaInfo: {
            title: 'Khonsu - MyAccountPage'
        },
        components: {
            AppHero,
            YourPlan,
            // BrandTools,
            CallToAction,
            AccountSettings
        },
        computed: {
            username: function () {
                return userMixin.methods.getUserName().toString();
            },
        },
    }
</script>